const textilePrint = {
  state: {
    technologies: {
      silkScreen: {
        id: 'silkScreen',
        label: 'Шелкография',
        allowsColorPick: true,
        maxColorsNumber: 6,
        minQuantity: 1, // минимальный тираж, необходимый для возможности заказа
        printFormPrice: 1000,
        priceList: [
          {
            from: 1,
            colorsNumber: {
              is1: 72,
              is2: 105,
              is3: 130,
              is4: 155,
              is5: 180,
              is6: 210,
            },
          },
          {
            from: 100,
            colorsNumber: {
              is1: 50,
              is2: 65,
              is3: 82,
              is4: 105,
              is5: 120,
              is6: 138,
            },
          },
          {
            from: 200,
            colorsNumber: {
              is1: 41,
              is2: 53,
              is3: 65,
              is4: 80,
              is5: 90,
              is6: 105,
            },
          },
          {
            from: 300,
            colorsNumber: {
              is1: 36,
              is2: 42,
              is3: 52,
              is4: 63,
              is5: 85,
              is6: 92,
            },
          },
          {
            from: 500,
            colorsNumber: {
              is1: 27,
              is2: 38,
              is3: 44,
              is4: 53,
              is5: 66,
              is6: 74,
            },
          },
          {
            from: 1000,
            colorsNumber: {
              is1: 24,
              is2: 31,
              is3: 37,
              is4: 42,
              is5: 47,
              is6: 56,
            },
          },
          {
            from: 2000,
            colorsNumber: {
              is1: 21,
              is2: 25,
              is3: 32,
              is4: 37,
              is5: 45,
              is6: 50,
            },
          },
          {
            from: 5000,
            colorsNumber: {
              is1: 15,
              is2: 21,
              is3: 25,
              is4: 31,
              is5: 36,
              is6: 41,
            },
          },
          {
            from: 10000,
            colorsNumber: {
              is1: 12,
              is2: 16,
              is3: 22,
              is4: 27,
              is5: 34,
              is6: 37,
            },
          },
        ],
        priceFactors: {
          quantity: [
            {
              productTypeID: 'baseballCaps',
              priceList: [
                { from: 1, priceAdd: 30, },
                { from: 100, priceAdd: 25, },
                { from: 200, priceAdd: 20, },
                { from: 300, priceAdd: 15, },
                { from: 500, priceAdd: 12, },
                { from: 1000, priceAdd: 9, },
                { from: 2000, priceAdd: 7, },
                { from: 5000, priceAdd: 6, },
                { from: 10000, priceAdd: 5, },
              ],
            }
          ],
        },
      },
      fullColor: {
        id: 'fullColor',
        label: 'Полноцветная печать',
        allowsColorPick: false,
        minQuantity: 1, // минимальный тираж, необходимый для возможности заказа
        initialExpences: 1000,
        priceList: [
          {
            from: 1,
            square: {
              'a6-10x15': 220,
              'a5-15x20': 300,
              'a4-20x30': 400,
              'a3-30x40': 500,
            },
          },
          {
            from: 6,
            square: {
              'a6-10x15': 200,
              'a5-15x20': 280,
              'a4-20x30': 360,
              'a3-30x40': 450,
            },
          },
          {
            from: 11,
            square: {
              'a6-10x15': 190,
              'a5-15x20': 260,
              'a4-20x30': 340,
              'a3-30x40': 400,
            },
          },
          {
            from: 21,
            square: {
              'a6-10x15': 180,
              'a5-15x20': 250,
              'a4-20x30': 320,
              'a3-30x40': 380,
            },
          },
          {
            from: 31,
            square: {
              'a6-10x15': 185,
              'a5-15x20': 235,
              'a4-20x30': 300,
              'a3-30x40': 350,
            },
          },
          {
            from: 51,
            square: {
              'a6-10x15': 160,
              'a5-15x20': 190,
              'a4-20x30': 270,
              'a3-30x40': 300,
            },
          },
          {
            from: 101,
            square: {
              'a6-10x15': 140,
              'a5-15x20': 170,
              'a4-20x30': 220,
              'a3-30x40': 280,
            },
          },
          {
            from: 201,
            square: {
              'a6-10x15': 110,
              'a5-15x20': 140,
              'a4-20x30': 190,
              'a3-30x40': 240,
            },
          },
          {
            from: 500,
            square: {
              'a6-10x15': 90,
              'a5-15x20': 120,
              'a4-20x30': 160,
              'a3-30x40': 210,
            },
          },
        ],
        priceFactors: {
          /**
           * squareFrom - выражено в кв. см
           */
          square: [
            {
              quantityFrom: 1,
              perCmAdd: 2,
            },
            {
              quantityFrom: 6,
              perCmAdd: 1.7,
            },
            {
              quantityFrom: 11,
              perCmAdd: 1.5,
            },
            {
              quantityFrom: 21,
              perCmAdd: 1.2,
            },
            {
              quantityFrom: 31,
              perCmAdd: 0.9,
            },
            {
              quantityFrom: 51,
              perCmAdd: 0.7,
            },
            {
              quantityFrom: 101,
              perCmAdd: 0.6,
            },
            {
              quantityFrom: 201,
              perCmAdd: 0.4,
            },
            {
              quantityFrom: 500,
              perCmAdd: 0.3,
            },
          ],
        },
      },
      embroidery: {
        id: 'embroidery',
        label: 'Вышивка',
        allowsColorPick: false,
        minQuantity: 1, // минимальный тираж, необходимый для возможности заказа
        initialExpences: 1500,
        priceList: [
          {
            from: 1,
            price: 1000,
          },
          {
            from: 5,
            price: 500,
          },
          {
            from: 10,
            price: 450,
          },
          {
            from: 20,
            price: 330,
          },
          {
            from: 30,
            price: 270,
          },
          {
            from: 40,
            price: 209,
          },
          {
            from: 50,
            price: 190,
          },
          {
            from: 70,
            price: 140,
          },
          {
            from: 100,
            price: 120,
          },
          {
            from: 300,
            price: 108,
          },
          {
            from: 500,
            price: 95,
          },
          {
            from: 1000,
            price: 88,
          },
          {
            from: 2000,
            price: 78,
          },
          {
            from: 5000,
            price: 72,
          },
        ],
        priceFactors: {
          /**
           * squareFrom - выражено в кв. см
           */
          square: [
            {
              quantityFrom: 1,
              priceList: [
                { squareFrom: 10, perCmAdd: 20 },
                { squareFrom: 30, perCmAdd: 20 },
                { squareFrom: 50, perCmAdd: 20 },
                { squareFrom: 80, perCmAdd: 20 },
                { squareFrom: 120, perCmAdd: 20 },
                { squareFrom: 300, perCmAdd: 20 },
                { squareFrom: 1000, perCmAdd: 20 },
              ],
            },
            {
              quantityFrom: 5,
              priceList: [
                { squareFrom: 10, perCmAdd: 15 },
                { squareFrom: 30, perCmAdd: 15 },
                { squareFrom: 50, perCmAdd: 15 },
                { squareFrom: 80, perCmAdd: 15 },
                { squareFrom: 120, perCmAdd: 15 },
                { squareFrom: 300, perCmAdd: 15 },
                { squareFrom: 1000, perCmAdd: 15 },
              ],
            },
            {
              quantityFrom: 10,
              priceList: [
                { squareFrom: 10, perCmAdd: 12 },
                { squareFrom: 30, perCmAdd: 12 },
                { squareFrom: 50, perCmAdd: 11 },
                { squareFrom: 80, perCmAdd: 10 },
                { squareFrom: 120, perCmAdd: 9 },
                { squareFrom: 300, perCmAdd: 9 },
                { squareFrom: 1000, perCmAdd: 9 },
              ],
            },
            {
              quantityFrom: 20,
              priceList: [
                { squareFrom: 10, perCmAdd: 11 },
                { squareFrom: 30, perCmAdd: 11 },
                { squareFrom: 50, perCmAdd: 10 },
                { squareFrom: 80, perCmAdd: 9 },
                { squareFrom: 120, perCmAdd: 8 },
                { squareFrom: 300, perCmAdd: 8 },
                { squareFrom: 1000, perCmAdd: 8 },
              ],
            },
            {
              quantityFrom: 30,
              priceList: [
                { squareFrom: 10, perCmAdd: 10 },
                { squareFrom: 30, perCmAdd: 10 },
                { squareFrom: 50, perCmAdd: 9 },
                { squareFrom: 80, perCmAdd: 8 },
                { squareFrom: 120, perCmAdd: 8 },
                { squareFrom: 300, perCmAdd: 8 },
                { squareFrom: 1000, perCmAdd: 8 },
              ],
            },
            {
              quantityFrom: 40,
              priceList: [
                { squareFrom: 10, perCmAdd: 9 },
                { squareFrom: 30, perCmAdd: 9 },
                { squareFrom: 50, perCmAdd: 8 },
                { squareFrom: 80, perCmAdd: 8 },
                { squareFrom: 120, perCmAdd: 7 },
                { squareFrom: 300, perCmAdd: 7 },
                { squareFrom: 1000, perCmAdd: 7 },
              ],
            },
            {
              quantityFrom: 50,
              priceList: [
                { squareFrom: 10, perCmAdd: 7 },
                { squareFrom: 30, perCmAdd: 6 },
                { squareFrom: 50, perCmAdd: 6 },
                { squareFrom: 80, perCmAdd: 6 },
                { squareFrom: 120, perCmAdd: 5 },
                { squareFrom: 300, perCmAdd: 5 },
                { squareFrom: 1000, perCmAdd: 5 },
              ],
            },
            {
              quantityFrom: 70,
              priceList: [
                { squareFrom: 10, perCmAdd: 5 },
                { squareFrom: 30, perCmAdd: 4.5 },
                { squareFrom: 50, perCmAdd: 4.5 },
                { squareFrom: 80, perCmAdd: 4 },
                { squareFrom: 120, perCmAdd: 4 },
                { squareFrom: 300, perCmAdd: 4 },
                { squareFrom: 1000, perCmAdd: 3.8 },
              ],
            },
            {
              quantityFrom: 100,
              priceList: [
                { squareFrom: 10, perCmAdd: 4 },
                { squareFrom: 30, perCmAdd: 4 },
                { squareFrom: 50, perCmAdd: 4 },
                { squareFrom: 80, perCmAdd: 3.5 },
                { squareFrom: 120, perCmAdd: 3.5 },
                { squareFrom: 300, perCmAdd: 3.5 },
                { squareFrom: 1000, perCmAdd: 3.3 },
              ],
            },
            {
              quantityFrom: 300,
              priceList: [
                { squareFrom: 10, perCmAdd: 3 },
                { squareFrom: 30, perCmAdd: 3 },
                { squareFrom: 50, perCmAdd: 3 },
                { squareFrom: 80, perCmAdd: 2.8 },
                { squareFrom: 120, perCmAdd: 2.8 },
                { squareFrom: 300, perCmAdd: 2.8 },
                { squareFrom: 1000, perCmAdd: 2.7 },
              ],
            },
            {
              quantityFrom: 500,
              priceList: [
                { squareFrom: 10, perCmAdd: 2.5 },
                { squareFrom: 30, perCmAdd: 2.5 },
                { squareFrom: 50, perCmAdd: 2.5 },
                { squareFrom: 80, perCmAdd: 2.4 },
                { squareFrom: 120, perCmAdd: 2.4 },
                { squareFrom: 300, perCmAdd: 2.3 },
                { squareFrom: 1000, perCmAdd: 2.2 },
              ],
            },
            {
              quantityFrom: 1000,
              priceList: [
                { squareFrom: 10, perCmAdd: 2.4 },
                { squareFrom: 30, perCmAdd: 2.4 },
                { squareFrom: 50, perCmAdd: 2.4 },
                { squareFrom: 80, perCmAdd: 2.3 },
                { squareFrom: 120, perCmAdd: 2.3 },
                { squareFrom: 300, perCmAdd: 2.2 },
                { squareFrom: 1000, perCmAdd: 2.1 },
              ],
            },
            {
              quantityFrom: 2000,
              priceList: [
                { squareFrom: 10, perCmAdd: 2.2 },
                { squareFrom: 30, perCmAdd: 2.2 },
                { squareFrom: 50, perCmAdd: 2.2 },
                { squareFrom: 80, perCmAdd: 2.1 },
                { squareFrom: 120, perCmAdd: 2.1 },
                { squareFrom: 300, perCmAdd: 2 },
                { squareFrom: 1000, perCmAdd: 1.9 },
              ],
            },
            {
              quantityFrom: 5000,
              priceList: [
                { squareFrom: 10, perCmAdd: 2 },
                { squareFrom: 30, perCmAdd: 2 },
                { squareFrom: 50, perCmAdd: 2 },
                { squareFrom: 80, perCmAdd: 1.9 },
                { squareFrom: 120, perCmAdd: 1.9 },
                { squareFrom: 300, perCmAdd: 1.8 },
                { squareFrom: 1000, perCmAdd: 1.7 },
              ],
            },
          ],
        },
      },
      bagPrint: {
        id: 'bagPrint',
        label: 'Печать',
        allowsColorPick: true,
        maxColorsNumber: 4,
        minQuantity: 100, // минимальный тираж, необходимый для возможности заказа
        printFormPrice: 0,
        priceList: [
          {
            from: 100, // тираж от
            colorsNumber: {
              is1: 41,
              is2: 56,
              is3: 72,
              is4: 91,
            },
          },
          {
            from: 200, // тираж от
            colorsNumber: {
              is1: 32,
              is2: 44,
              is3: 58,
              is4: 75,
            },
          },
          {
            from: 300, // тираж от
            colorsNumber: {
              is1: 25,
              is2: 37,
              is3: 49,
              is4: 63,
            },
          },
          {
            from: 500, // тираж от
            colorsNumber: {
              is1: 22,
              is2: 30,
              is3: 39,
              is4: 49,
            },
          },
          {
            from: 1000, // тираж от
            colorsNumber: {
              is1: 15,
              is2: 23,
              is3: 30,
              is4: 38,
            },
          },
          {
            from: 2000, // тираж от
            colorsNumber: {
              is1: 14,
              is2: 20,
              is3: 27,
              is4: 34,
            },
          },
          {
            from: 3000, // тираж от
            colorsNumber: {
              is1: 13,
              is2: 19,
              is3: 25,
              is4: 31,
            },
          },
          {
            from: 5000, // тираж от
            colorsNumber: {
              is1: 13,
              is2: 18,
              is3: 23,
              is4: 29,
            },
          },
          {
            from: 7000, // тираж от
            colorsNumber: {
              is1: 12,
              is2: 17,
              is3: 22,
              is4: 27,
            },
          },
          {
            from: 10000, // тираж от
            colorsNumber: {
              is1: 11,
              is2: 15,
              is3: 20,
              is4: 25,
            },
          },
        ],
      },
    },
    locations: {
      front: {
        id: 'front',
        name: 'Грудь',
        allowedTechnologies: ['silkScreen', 'fullColor', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20', 'a4-20x30', 'a3-30x40'],
          fullColor: ['a6-10x15', 'a5-15x20', 'a4-20x30', 'a3-30x40', 'custom'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      sleeveLeft: {
        id: 'sleeveLeft',
        name: 'Левый рукав',
        allowedTechnologies: ['silkScreen', 'fullColor', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20'],
          fullColor: ['a6-10x15', 'a5-15x20', 'custom'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1.1,
          fullColor: 1,
          embroidery: 1.25,
        },
      },
      sleeveRight: {
        id: 'sleeveRight',
        name: 'Правый рукав',
        allowedTechnologies: ['silkScreen', 'fullColor', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20'],
          fullColor: ['a6-10x15', 'a5-15x20', 'custom'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1.1,
          fullColor: 1,
          embroidery: 1.25,
        },
      },
      back: {
        id: 'back',
        name: 'Спина',
        allowedTechnologies: ['silkScreen', 'fullColor', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20', 'a4-20x30', 'a3-30x40'],
          fullColor: ['a6-10x15', 'a5-15x20', 'a4-20x30', 'a3-30x40', 'custom'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      frontPocket: {
        id: 'frontPocket',
        name: 'Передний карман',
        allowedTechnologies: ['silkScreen', 'fullColor', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20', 'a4-20x30', 'a3-30x40'],
          fullColor: ['a6-10x15', 'a5-15x20', 'a4-20x30', 'a3-30x40', 'custom'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      baseballCapForehead: {
        id: 'baseballCapForehead',
        name: 'Лоб',
        allowedTechnologies: ['silkScreen', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      baseballCapBack: {
        id: 'baseballCapBack',
        name: 'Затылок',
        allowedTechnologies: ['silkScreen', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      baseballCapTempleLeft: {
        id: 'baseballCapTempleLeft',
        name: 'Левый висок',
        allowedTechnologies: ['silkScreen', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1.25,
        },
      },
      baseballCapTempleRight: {
        id: 'baseballCapTempleRight',
        name: 'Правый висок',
        allowedTechnologies: ['silkScreen', 'embroidery'],
        allowedSquares: {
          silkScreen: ['10x10', 'a6-10x15', 'a5-15x20'],
          embroidery: ['custom'],
        },
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1.25,
        },
      },
      bagFront: {
        id: 'bagFront',
        name: 'Лицевая сторона',
        allowedTechnologies: ['bagPrint'],
        allowedSquares: {
          bagPrint: ['bagCustom'],
        },
        printPriceMultiplier: {
          bagPrint: 1,
        },
      },
      bagBack: {
        id: 'bagBack',
        name: 'Обратная сторона',
        allowedTechnologies: ['bagPrint'],
        allowedSquares: {
          bagPrint: ['bagCustom'],
        },
        printPriceMultiplier: {
          bagPrint: 1,
        },
      },
    },
    squares: {
      '10x10': {
        id: '10x10',
        label: '10x10',
        w: 10,
        h: 10,
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      'a6-10x15': {
        id: 'a6-10x15',
        label: 'A6 (10x15)',
        w: 10,
        h: 15,
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      'a5-15x20': {
        id: 'a5-15x20',
        label: 'A5 (15x20)',
        w: 15,
        h: 20,
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      'a4-20x30': {
        id: 'a4-20x30',
        label: 'A4 (20x30)',
        w: 20,
        h: 30,
        printPriceMultiplier: {
          silkScreen: 1,
          fullColor: 1,
          embroidery: 1,
        },
      },
      'a3-30x40': {
        id: 'a3-30x40',
        label: 'A3 (30x40)',
        w: 30,
        h: 40,
        printPriceMultiplier: {
          silkScreen: 1.4,
          fullColor: 1,
          embroidery: 1,
        },
      },
      'custom': {
        id: 'custom',
        label: 'Указать',
        units: 'см',
        // ширина и высота по умолчанию для различных мест нанесения (this.state.locations)
        defaults: {
          default: { w: 31, h: 41 },
          baseballCapForehead: { w: 10, h: 6 },
          baseballCapBack: { w: 5, h: 5 },
          baseballCapTempleLeft: { w: 5, h: 5 },
          baseballCapTempleRight: { w: 5, h: 5 },
        },
        // макс. ширина и высота для различных мест нанесения (this.state.locations)
        max: {
          default: { w: 80, h: 80 },
          baseballCapForehead: { w: 10, h: 6 },
          baseballCapBack: { w: 5, h: 5 },
          baseballCapTempleLeft: { w: 5, h: 5 },
          baseballCapTempleRight: { w: 5, h: 5 },
        },
        printPriceMultiplier: {
          fullColor: 1,
          embroidery: 1,
        },
      },
      'bagCustom': {
        id: 'bagCustom',
        label: 'Площадь',
        units: 'мм',
        defaults: {
          w: 300,
          h: 300,
        },
        maxW: 350,
        maxH: 320,
        printPriceMultiplier: {
          bagPrint: 1,
        },
      },
    },
    colors: [
      // needsSubstrate: нужна ли подложка для этого цвета на цветном текстиле
      {
        name: 'белый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'бронзовый',
        needsSubstrate: false,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'голубой',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'желтый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'зеленый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'золотой',
        needsSubstrate: false,
        printPriceMultiplier: {
          textile: 1.5,
          bags: 1.2,
        },
      },
      {
        name: 'коричневый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'красный',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'оранжевый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'серебряный',
        needsSubstrate: false,
        printPriceMultiplier: {
          textile: 1.5,
          bags: 1.2,
        },
      },
      {
        name: 'серый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'синий',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'фиолетовый',
        needsSubstrate: true,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
      {
        name: 'черный',
        needsSubstrate: false,
        printPriceMultiplier: {
          textile: 1,
          bags: 1,
        },
      },
    ],
  },
}

export default textilePrint